import { Company, User, Pivot } from 'api';
import { AppEpic } from 'model';
import { combineEpics } from 'redux-observable';
import { filter, map, mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';

import {
  getCompanyList, getUserInfo, setCompanyList, setReadMeetingRecord, updateReadMeetingRecord,
  setUserInfo, updateMeetingReviewTime, getSSOUserInfo
} from '.';
import { getMeetingDetailsV2 } from 'model/meeting';
import { appMessageSuccess } from 'model/app';
import { fridayAgent } from '@cvte/react-fridayagent3';
import friday from 'lib/tracker/friday';

type GetUserInfoAction = ReturnType<typeof getUserInfo>
type GetCompanyListAction = ReturnType<typeof getCompanyList>
type UpdateMeetingReviewTimeAction = ReturnType<typeof updateMeetingReviewTime>
type SetReadMeetingRecordAction = ReturnType<typeof setReadMeetingRecord>

const getUserInfoEpic: AppEpic = (action$) => action$.pipe(
  filter(getUserInfo.match),
  mergeMap(
    () => Pivot.getStaff().pipe(
      map((res) => {
        // 进行埋点 fridayAgent.setUser
        const { data } = res as any;
        friday.setStaffInfo(data);
        fridayAgent.setUser({ id: data.userId });
        return setUserInfo(data);
      })
    )
  )
);

const getSSOUserInfoEpic: AppEpic = (action$) => action$.pipe(
  filter(getSSOUserInfo.match),
  mergeMap(
    (action) => Pivot.getStaffInfo(action.payload.companyId, action.payload.userId).pipe(
      map((res) => {
        // 进行埋点 fridayAgent.setUser
        const { data: user } = res as any;
        friday.setStaffInfo(user);
        fridayAgent.setUser({ id: user.userId });
        return setUserInfo(user);
      })
    )
  )
);

const getCompanyListEpic: AppEpic = (action$) => action$.pipe(
  filter(getCompanyList.match),
  mergeMap(
    () => Company.getCompanyList().pipe(
      map((data) => setCompanyList(data))
    )
  )
);

const updateMeetingReviewTimeEpic: AppEpic = (action$) => action$.pipe(
  filter(updateMeetingReviewTime.match),
  mergeMap(
    (action) => User.updateMeetingReviewTime(action.payload.userId, action.payload.meetingId).pipe(
      mergeMap(() => of(getMeetingDetailsV2(action.payload.meetingId)))
    )
  )
);

const setReadMeetingRecordEpic: AppEpic = (action$) => action$.pipe(
  filter(setReadMeetingRecord.match),
  mergeMap(
    (action: SetReadMeetingRecordAction) => User.readMeetingRecord(action.payload.staffId, action.payload.meetingId).pipe(
      mergeMap(() => of(getMeetingDetailsV2(action.payload.meetingId)))
    )
  )
);

const updateReadMeetingRecordEpic: AppEpic = (action$) => action$.pipe(
  filter(updateReadMeetingRecord.match),
  mergeMap(
    (action: SetReadMeetingRecordAction) => User.readMeetingRecord(action.payload.staffId, action.payload.meetingId).pipe(
      mergeMap(() => of(appMessageSuccess('')))
    )
  )
);

export type UserEpicActions = GetUserInfoAction | GetCompanyListAction | UpdateMeetingReviewTimeAction | SetReadMeetingRecordAction;

export default combineEpics(getUserInfoEpic, getCompanyListEpic, updateMeetingReviewTimeEpic, setReadMeetingRecordEpic, updateReadMeetingRecordEpic, getSSOUserInfoEpic);
